export default __webpack_public_path__ + "static/media/telagram.75bbe31d.svg";